var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdminCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Iconly/Bulk/Calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.615,
    height: 20.683
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7e7e7e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 1",
    d: "M5.3 20.683A4.939 4.939 0 010 15.378V7.505h18.615v7.937c0 3.246-2.043 5.242-5.313 5.242z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 4",
    d: "M.003 7.505a16.4 16.4 0 01.16-2.2 4.748 4.748 0 014.54-3.764h9.216a4.8 4.8 0 014.536 3.764 16.435 16.435 0 01.159 2.2z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 6",
    d: "M5.486 4.747a.772.772 0 00.787-.8V.8a.773.773 0 00-.787-.8.773.773 0 00-.787.8v3.151a.772.772 0 00.787.8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 9",
    d: "M13.129 4.747a.778.778 0 00.787-.8V.8a.779.779 0 00-.787-.8.773.773 0 00-.787.8v3.151a.772.772 0 00.787.8"
  }))));
}

export default SvgAdminCalendar;